export const isNumber = (val: any): boolean => typeof val == "number" && !isNaN(val);

export const encodeDate = (date: Date): string => {
  const y = date.getFullYear();
  const m = date.getMonth() + 1;
  const d = date.getDate();

  return `${y}-${("0" + m).slice(-2)}-${("0" + d).slice(-2)}`;
};

export const getTsQueryValue = (value: string): string => (
    `ilike.${
       value
          .split(/\s/)
          .filter(i => i !== "")
          .map(i => "*" + i + "*")
          .join(" ")
    }`
    // [Other options] https://www.postgresql.org/docs/11/textsearch-controls.html
    // `fts.${value.split(/[\W,;-]/).filter(ph => ph !== "").map(ph => `${ph}:*`).join("&")}`
    // `plfts.${value.trim()}`
);
